import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/Hotel/tab/General/Notice/Views/notice.html';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {hotelService} from '@/Pages/Admin/Modules/Hotel/Services/HotelService'
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import { HotelModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelModel";
@WithRender
@Component({
    components: {
        'validation-error': ValidationError,
    },
})
export default class Notice extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    noticeData: false,
                },
                postLoading: {
                    addNotice: false,
                },
                canEdit: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            noticeData: new HotelModel({}),
            tempNoticeData: new HotelModel({}),
        };
    }

    public mounted() {
        this.getNoticesData();
    }

    public getNoticesData() {
        this.ui.status.isLoading.noticeData = true;
        let data = {
            hotel_id: this.$route.query.id,
        };
        hotelService.getNotice(data)
            .then((res: any) => {
                this.item.noticeData = res.data.data;
            })
            .catch((error: any) => {
                this.ui.error.errors = error;
            })
            .finally(() => {
                this.ui.status.isLoading.noticeData = false;
            });
    }

    protected createNotice() {
        this.resetError();

        let data = {
            hotel_id: this.$route.query.id,
            fees_notice: this.item.noticeData.fees_notice,
            mention_notice: this.item.noticeData.mention_notice,
        };
        this.ui.status.postLoading.addNotice = true;
        hotelService
            .updateNotice(data)
            .then((res: any) => {
                flashService.Success('Notice Added', res.data.message);
                this.ui.status.canEdit = false;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message)
                    .then((res) => {
                        this.ui.error.error_message = res;
                    });
                flashService.Error('Error', 'Error while adding general notice.');
            })
            .finally(() => {
                this.ui.status.postLoading.addNotice = false;
            });
    }

    public get buttonName() {
        if (this.ui.status.postLoading.addNotice) {
            return 'Processing...';
        }
        return 'Save';
    }

    protected onEditNoticeClick() {
        this.ui.status.canEdit = true;
        this.item.tempNoticeData = Object.assign({}, this.item.noticeData);
    }

    protected cancelNotice() {
        this.ui.status.canEdit = false;
        this.resetError();
        this.item.noticeData = this.item.tempNoticeData;
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }
}
